import * as React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { CircularProgress } from "@mui/material";
import axios from "axios";

import TicketForm from "../../components/Admin/forms/TicketForm";
import CommonContainer from "../../components/common/container/CommonContainer";
import useSnackbarAlert from "../../utils/snackbarHandlers";

const EditTicket: React.FC = () => {
  //@ts-ignore
  const config = window.config;
  const apiBaseURL = config?.server || "http://18.217.95.31:8080";
  const [data, setData] = React.useState<any>({
    ticketTitle: "",
    ticketNumber: "",
    slotNumber: "",
    image: "",
    ticketPrice: "",
    ticketDescription: "",
    startDate: "",
    closeDate: "",
    numberOfPack: "",
  });
  const { t } = useTranslation("translation");
  const [loading, setLoading] = React.useState(false);
  const [initialLoading, setInitialLoading] = React.useState(false);
  const [image, setImage] = React.useState<string>("");
  const { id } = useParams();
  const navigate = useNavigate();
  const { showErrorMessage, showSuccessMessage } = useSnackbarAlert();

  const getParticularTicketDetails = () => {
    setInitialLoading(true);
    axios
      .get(`${apiBaseURL}/api/ticket/fetchParticularTicketDetail?id=${id}`)
      .then((data: any) => {
        if (data?.status == 200) {
          let ticketData = data?.data?.ticket;
          setData({
            ticketTitle: ticketData?.ticketTitle,
            ticketNumber: ticketData?.ticketNumber,
            slotNumber: ticketData?.slotNumber,
            image: ticketData?.imageUrl,
            ticketPrice: ticketData?.ticketPrice,
            ticketDescription: ticketData?.ticketDescription,
            startDate: ticketData?.startDate,
            closeDate: ticketData?.closeDate,
            numberOfPack: ticketData?.numberOfPack,
          });
          setImage(ticketData?.imageUrl);
        }
      })
      .catch((err: any) => {
        console.log("err", err);
      })
      .finally(() => {
        setInitialLoading(false);
      });
  };

  const onHandleSubmit = (value: any) => {
    setLoading(true);
    const fileHeaders = {
      accept: "application/json",
      "Accept-Language": "en-US,en;q=0.8",
      "Content-Type": "multipart/form-data",
    };
    const body: any = {
      ticketTitle: value.ticketTitle,
      slotNumber: value.slotNumber,
      ticketNumber: value.ticketNumber,
      image: value.image,
      ticketPrice: value.ticketPrice,
      ticketDescription: value.ticketDescription,
      startDate: value.startDate,
      closeDate: value.closeDate,
      numberOfPack: value.numberOfPack,
    };
    const getDifference = (a: any, b: any) =>
      Object.fromEntries(Object.entries(b).filter(([key, val]) => key in a && a[key] !== val));
    const payload: any = getDifference(data, body);

    axios
      .put(`${apiBaseURL}/api/ticket/update?id=${id}`, payload, { headers: fileHeaders })
      .then((data: any) => {
        if (data?.status == 200) {
          showSuccessMessage(t("ticketAddSuccessfulMsg", "Ticket Added Successfully"));
          navigate("/admin/dashboard");
        }
      })
      .catch((err: any) => {
        console.log("err", err);
        showErrorMessage(t("updateTicketErrorMessage"));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  React.useEffect(() => {
    getParticularTicketDetails();
  }, []);

  return (
    <CommonContainer title={t("updateTicket")} description={t("updateTicketPageDescription")} backButtonurl="/admin/dashboard">
      {initialLoading ? (
        <CircularProgress />
      ) : (
        <TicketForm
          data={data}
          onFormSubmit={(values) => onHandleSubmit(values)}
          loading={loading}
          image={image}
          setImage={setImage}
          edit={true}
        />
      )}
    </CommonContainer>
  );
};

export default EditTicket;
